import React from 'react';
import { TextInput } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Icons = () => {
  return (
    <>
      <h4 className="mt-5">Types</h4>
      <p>
        Text Inputs can have <i>error</i>, <i>disabled</i> and <i>readonly</i> types.
      </p>
      <div className="mt-3">
        <TextInput className="single-btn" placeholder="Error Errorrr!" width="400px" error />
     </div>
     <div className="mt-3">
        <TextInput className="single-btn" placeholder="Disabled Input 😴" width='400px' disabled />
      </div>
      <div className="mt-3">
        <TextInput className="single-btn" placeholder="You can only read me 😈" width='400px' readonly />
      </div>
      <Row className="mt-3">
        <code>
          {'import { TextInput } from "chic-ui";'}
          <br />
          {'<TextInput placeholder="Error Erorrr!" width="400px" error />'}
          <br />
          {'<TextInput placeholder="Disabled Input 😴" width="400px" disabled />'}
          <br />
          {'<TextInput placeholder="You can only read me 😈" width="400px" disabled />'}
        </code>
      </Row>
    </>
  );
};

export default Icons;
